import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { SortedList } from "../../../Layout/SortedList";
import { getIsLoadingSelector } from "../../../../selectors/selectors";
import { getRepresentatives } from "../../../../actions";
import ListHeader from "./List/ListHeader";
import ListRow from "./List/ListRow";
import Time from "../../../Common/Time";

class Representative extends PureComponent {
  static propTypes = {
    getRepresentatives: PropTypes.func.isRequired,
    customerPOId: PropTypes.string,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    representatives: PropTypes.array
  };

  static defaultProps = {
    isLoading: false,
    isMobile: false,
    customerPOId: "",
    representatives: []
  };

  componentDidMount() {
    if (this.props.customerPOId) {
      this.props.getRepresentatives(this.props.customerPOId);
    }
  }

  get representatives() {
    return _(this.props.representatives)
      .groupBy(rep => `${rep.productFamily}--${rep.representativeType}--${rep.representativeName}`)
      .map((reps, id) => ({ id, reps }))
      .sortBy(rep => rep.id)
      .value();
  }

  render() {
    return (
      <div className="representative__container">
        <div className="representative__header">
          <p className="representative__title">{i18n.t("representative.title")}</p>
          <Time />
        </div>
        <div className="representative__contact-details">
          <SortedList
            RowComponent={ListRow}
            HeaderComponent={ListHeader}
            data={this.representatives}
            isMobile={this.props.isMobile}
            isLoading={this.props.isLoading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: getIsLoadingSelector(state, [getRepresentatives.id]),
    representatives: state.purchaseOrder.representatives
  };
};

export default connect(
  mapStateToProps,
  { getRepresentatives }
)(Representative);



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/Representative/Representative.js